import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 px-6 border-t border-border">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <p className="text-muted-foreground">{t("footer.copyright")}</p>
        </div>
        <div className="flex items-center">
          <p className="text-muted-foreground">{t("footer.madeWith")}</p>
        </div>
      </div>
    </footer>
  );
};
